import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdOutlineShoppingCart,
  MdOutlineMenuBook,
  MdOutlineRestaurant,
  MdOutlineDashboard,
  MdOutlineCampaign,
  MdOutlineInventory,
  MdOutlineAnalytics,
  MdSettings,
  MdOutlineLocalShipping,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "./views/admin/default";
import Campaigns from "./views/admin/campaigns";
import Profile from "./views/admin/profile";
import Menu from "./views/admin/menu";
import Orders from "./views/admin/orders";
import Stokcs from "./views/admin/stocks";
import Analysis from "./views/admin/analysis";
import PrivateRoute from "./components/PrivateRoute";
import Settings from "./views/admin/settings/profileSettings";
import Suppliers from "./views/admin/suppliers";

import { slugify } from './utils/slugify';

// Business name'i dinamik olarak almak için helper fonksiyon
const getAdminLayout = () => {
  try {
    const business = localStorage.getItem('business');
    if (business) {
      const businessData = JSON.parse(business);
      const businessName = businessData.name || businessData.businessName;
      if (businessName) {
        const slug = slugify(businessName);
        return `/admin/${slug}`;
      }
    }
  } catch (error) {
    console.error('Business layout oluşturma hatası:', error);
  }
  return '/admin';
};

// Routes'u fonksiyon olarak export et ki her kullanımda güncel layout'u alsın
export const getRoutes = () => {
  const adminLayout = getAdminLayout();
  
  return [
  {
    name: 'Kontrol Paneli',
    layout: adminLayout,
    path: '/panel',
    icon: <Icon as={MdOutlineDashboard} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
    showInSidebar: true
  },
  {
    name: 'Siparişler',
    layout: adminLayout,
    icon: <Icon as={MdOutlineShoppingCart} width="20px" height="20px" color="inherit" />,
    path: '/siparisler',
    component: <Orders />,
    showInSidebar: true
  },
  {
    name: 'Menü',
    layout: adminLayout,
    icon: <Icon as={MdOutlineMenuBook} width="20px" height="20px" color="inherit" />,
    path: '/menu',
    component: <Menu />,
    showInSidebar: true
  },
  {
    name: 'İşletmem',
    layout: adminLayout,
    path: '/isletmem',
    icon: <Icon as={MdOutlineRestaurant} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
    showInSidebar: true
  },
  {
    name: 'Kampanyalar',
    layout: adminLayout,
    path: '/kampanyalar',
    icon: <Icon as={MdOutlineCampaign} width="20px" height="20px" color="inherit" />,
    component: <Campaigns />,
    showInSidebar: true
  },
  {
    name: 'Stok Durumu',
    layout: adminLayout,
    path: '/stok-durumu',
    icon: <Icon as={MdOutlineInventory} width="20px" height="20px" color="inherit" />,
    component: <Stokcs />,
    showInSidebar: true
  },
  {
    name: 'Analiz ve Raporlama',
    layout: adminLayout,
    path: '/analiz',
    icon: <Icon as={MdOutlineAnalytics} width="20px" height="20px" color="inherit" />,
    component: <Analysis />,
    showInSidebar: true
  },
  {
    name: "Profil Ayarları",
    layout: adminLayout,
    path: "/profil-ayarlari",
    icon: <Icon as={MdSettings} width='20px' height='20px' color='inherit' />,
    component: <Settings />,
    showInSidebar: false
  },
  {
    name: 'Tedarikçiler',
    layout: adminLayout,
    path: '/tedarikciler',
    icon: <Icon as={MdOutlineLocalShipping} width="20px" height="20px" color="inherit" />,
    component: <Suppliers />,
    showInSidebar: true
  }
  ];
};

// Route'ları filtrele - sadece admin kontrolü yap
export const filterRoutes = () => {
  const userRole = JSON.parse(localStorage.getItem('user'))?.role;
  const routes = getRoutes();
  
  return routes.filter(route => {
    if (route.isAdminRoute && userRole !== 'admin') return false;
    return true;
  });
};

// Backward compatibility için default export - lazy evaluation
export default getRoutes();
